import axios from "axios"; // axios
import router from "../router";
import _ from "lodash";
import Common from "@/util/common.js";
import VueCookies from "vue-cookies";
import store from "@/store/index.js";

// axios.defaults.baseURL = process.env.VUE_APP_BASEURL;
// axios.defaults.timeout = 30000;
// axios.defaults.headers.post["Content-Type"] = "application/json;charset=UtF-8";

const net_common = axios.create({
  baseURL: process.env.VUE_APP_COMMON_BASEURL,
  timeout: 0,
  headers: { "Content-Type": "application/json;charset=UTF-8" },
  withCredentials: true,
});
/**
 * Request interception
 */
net_common.interceptors.request.use(requestInterceptors);

/**
 * response interception
 */
net_common.interceptors.response.use(responseInterceptors);

const net_filemanage = axios.create({
  baseURL: process.env.VUE_APP_FILEMANAGE_BASEURL,
  timeout: 0,
  headers: { "Content-Type": "application/json;charset=UTF-8" },
  withCredentials: true,
});
/**
 * Request interception
 */
net_filemanage.interceptors.request.use(requestInterceptors);

/**
 * response interception(暫定)
 */
net_filemanage.interceptors.response.use(responseInterceptors,errorInterceptors);

let pendingRequestCount = 0;

function requestInterceptors(config) {
  if (pendingRequestCount === 0) {
    store.commit("businessModule/setPendingStatus", true);
  }
  pendingRequestCount++;
  const token = VueCookies.get("SessionID");
  token && (config.headers.SessionID = `${token}`);
  if (
    config.data &&
    config.headers["Content-Type"].includes("application/json")
  ) {
    config.data = JSON.parse(JSON.stringify(config.data));
  } else if (config.method === "post" && !config.data) {
    config.data = {};
  }
  return config;
}

function responseInterceptors(response) {
  pendingRequestCount--;
  if (pendingRequestCount === 0) {
    store.commit("businessModule/setPendingStatus", false);
  }
  if (response.status === 200) {
    if (_.eq(response.data.result, "0000")) {
      return Promise.resolve(response.data);
    } else if (
      response.data.errorCD &&
       _.eq(response.data.errorCD.substr(0, 5), "MTCL0")) {
      // 遷移前に、処理中ダイアログを閉じる
      store.commit("businessModule/processDialogue", false);    
      //各種エラー画面へ遷移
      if(sessionStorage.getItem("toRedirectUrl")){
        router.push({
          name: "STDSCM04C07",
          state: {
            message: Common.getMessage(response.data.errorCD, []),
            errorCD: response.data.errorCD,
            errorMSG: response.data.errorMSG
          },
        });
        
      } else {
        router.push({
          name: "STDSCM04C06",
          state: {
            message: Common.getMessage(response.data.errorCD, [])
          },
        });
      }

      return Promise.reject(response.data);
    } else if( response.data.errorCD &&
      _.eq(response.data.errorCD.substr(0, 5), "MTFM0")) {
      // 遷移前に、処理中ダイアログを閉じる
      store.commit("businessModule/processDialogue", false);
      if(response.data.toRedirectUrl){
        sessionStorage.setItem(
          "toRedirectUrl",
          response.data.toRedirectUrl
        );
      }
      //各種エラー画面へ遷移
      router.push({
        name: "STDSCM04C07",
        state: {
          message: Common.getMessage(response.data.errorCD, []),
          errorCD: response.data.errorCD,
          errorMSG: response.data.errorMSG
        },
      });
      return Promise.reject(response.data);
    }else {
      window.scrollTo(0, 0);
      return Promise.resolve(response.data);
    }
  } else {
    // 遷移前に、処理中ダイアログを閉じる
    store.commit("businessModule/processDialogue",false)
    // XXX coverity 各種エラー画面へ遷移
    router.push({
      name: "STDSCM04C06",
      state: {
        message: "401",
      },
    });
    return Promise.reject(response.data);
  }
}
function errorInterceptors(err){
  // 遷移前に、処理中ダイアログを閉じる
  store.commit("businessModule/processDialogue",false)
  return  Promise.reject(err.response)
}

export { net_common, net_filemanage };
